export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Full width NJ map */}
      <div className="w-full h-[350px]">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1547626.6082490773!2d-75.55954785!3d39.8338515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c0fb959e00409f%3A0x2cd27b07e3f4f459!2sNew%20Jersey!5e0!3m2!1sen!2sus!4v1749674000001!5m2!1sen!2sus"
          width="100%"
          height="100%"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="NJ Commercial Asphalt Service Area"
          className="w-full h-full border-0"
        ></iframe>
      </div>

      {/* Footer */}
      <footer
        className="text-white pt-16 pb-6"
        id="contact"
        style={{
          backgroundImage: `url(https://www.advancedasphaltca.com/wp-content/uploads/2025/06/footer-bg-e1749464943379.png)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundColor: '#1a1a1a',
        }}
      >
        <div className="max-w-7xl mx-auto px-6">
          {/* CTA */}
          <div className="mb-12">
            <h2
              className="text-4xl md:text-5xl font-extrabold uppercase mb-6 leading-tight"
              style={{ fontFamily: "'Oswald', sans-serif" }}
            >
              Contact
              <br />
              Us Today
            </h2>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#contact"
                className="border-2 border-white text-white font-bold uppercase text-sm px-8 py-3 rounded-sm hover:bg-white hover:text-gray-900 transition-colors whitespace-nowrap text-center"
              >
                Contact
              </a>
              <a
                href="tel:8566776191"
                className="border-2 border-white text-white font-bold uppercase text-sm px-8 py-3 rounded-sm hover:bg-white hover:text-gray-900 transition-colors whitespace-nowrap text-center"
              >
                Call (856) 677-6191
              </a>
            </div>
          </div>

          {/* Footer columns */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-white/20 pt-10">
            {/* About */}
            <div>
              <h4
                className="text-sm font-bold uppercase tracking-widest text-white border-b-2 border-yellow-400 pb-2 mb-5 inline-block"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                About Company
              </h4>
              <p className="text-gray-300 text-sm leading-relaxed">
                NJ Commercial Asphalt Paving provides premium commercial paving services across the entire state of New Jersey, including asphalt paving, sealcoating, parking lot repair, crack filling, and pavement maintenance. Our team is fast, clean, and courteous — and we have immediate availability for all projects large and small.
              </p>
            </div>

            {/* Quick links */}
            <div>
              <h4
                className="text-sm font-bold uppercase tracking-widest text-white border-b-2 border-yellow-400 pb-2 mb-5 inline-block"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                Useful Links
              </h4>
              <ul className="space-y-2">
                {['Home', 'About', 'Services', 'Testimonials', 'FAQ', 'Contact'].map((item) => (
                  <li key={item}>
                    <a
                      href={`#${item.toLowerCase()}`}
                      className="text-gray-300 text-sm hover:text-yellow-400 transition-colors"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact info */}
            <div>
              <h4
                className="text-sm font-bold uppercase tracking-widest text-white border-b-2 border-yellow-400 pb-2 mb-5 inline-block"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                Contact Us
              </h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-map-pin-line text-yellow-400 text-lg"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    <strong className="text-white">NJ Commercial Asphalt Paving</strong>
                    <br />
                    Serving All of New Jersey
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-line text-yellow-400 text-lg"></i>
                  </div>
                  <a
                    href="tel:8566776191"
                    className="text-gray-300 text-sm hover:text-yellow-400 transition-colors"
                  >
                    (856) 677-6191
                  </a>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-time-line text-yellow-400 text-lg"></i>
                  </div>
                  <p className="text-gray-300 text-sm">
                    Immediate Availability
                    <br />
                    Call us anytime for a quote
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Sub-footer */}
          <div className="mt-10 pt-6 border-t border-white/20 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-gray-400 text-sm text-center sm:text-left">
              &copy; Copyright {currentYear} NJ Commercial Asphalt Paving. | All Rights Reserved
            </p>
            <a
              href="tel:8566776191"
              className="text-yellow-400 font-bold text-sm hover:underline whitespace-nowrap"
            >
              (856) 677-6191
            </a>
          </div>
        </div>
      </footer>

      {/* Floating CTA button */}
      <a
        href="#contact"
        className="fixed right-0 top-1/2 -translate-y-1/2 bg-yellow-400 text-gray-900 font-bold text-xs uppercase tracking-widest px-3 py-5 z-40 hover:bg-yellow-300 transition-colors whitespace-nowrap cursor-pointer"
        style={{
          writingMode: 'vertical-rl',
          textOrientation: 'mixed',
          transform: 'translateY(-50%) rotate(180deg)',
        }}
      >
        Request Estimate
      </a>
    </>
  );
}
